import { render } from "./alertTips.vue?vue&type=template&id=bf307ac8&scoped=true&ts=true"
import script from "./alertTips.vue?vue&type=script&lang=ts"
export * from "./alertTips.vue?vue&type=script&lang=ts"

import "./alertTips.vue?vue&type=style&index=0&id=bf307ac8&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf307ac8"]])

export default __exports__